var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zR0IwLeuWUhwT8{padding:12px 16px;box-sizing:border-box;margin-left:40px;background-color:#eddbf4;background-image:url(" + escape(require("resources/images/checklists/pointing-hand.svg")) + ");background-repeat:no-repeat;background-position:400px 0;position:relative}._228u0oBjRyf8cP{font-size:14px;line-height:16px;margin-bottom:8px;max-width:380px}._1qSUUV_YosWbD8,._2diQbNrV2iSpKK{font-size:14px}._1qSUUV_YosWbD8{color:#5e6c84}.hMpDzGr8w-B1F4{position:absolute;top:16px;right:16px;padding:0;background-color:transparent;line-height:14px;color:#42526e}.hMpDzGr8w-B1F4:hover{color:#505f79}.hMpDzGr8w-B1F4:active{color:#5e6c84}", ""]);

// exports
exports.locals = {
	"banner": "zR0IwLeuWUhwT8",
	"heading": "_228u0oBjRyf8cP",
	"content": "_2diQbNrV2iSpKK",
	"footer": "_1qSUUV_YosWbD8",
	"dismiss": "hMpDzGr8w-B1F4"
};